import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandPrimaryText, destructive } from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';

const MinBodyInputsWidth = 450;
export const styleSheet = StyleSheet.create({
	body: {
		'@media only screen and (min-height: 1024px)': {
			height: 660,
			maxHeight: 660,
			minHeight: 660,
		},
		'@media only screen and (min-height: 768px)': {
			height: 460,
			maxHeight: 600,
			minHeight: 460,
		},
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		marginTop: 16,
	},
	emailComposerTemplatesSelectorButton: {
		marginTop: 10,
	},
	bodyInputs: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		flexShrink: 0,
		maxHeight: '100%',
		minWidth: MinBodyInputsWidth,
		position: 'relative',
	},
	footer: {
		marginTop: 20,
	},
	header: {
		color: brandPrimaryText,
		fontSize: 24,
		margin: 0,
		padding: 0,
	},
	leftContainer: {
		border: '1px solid rgb(202, 224, 236)',
		borderRadius: 3,
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		padding: '1rem',
	},
	modalBody: {
		boxSizing: 'border-box',
		display: 'flex',
		height: 'calc(100% - 50px)',
		gap: 16,
	},
	modalContent: {
		backgroundColor: 'white',
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		width: '100%',
	},
	modalHeader: {
		alignItems: 'center',
		backgroundColor: brandPrimary,
		display: 'flex',
		flex: '0 0 50px',
		paddingLeft: 20,
		paddingRight: 20,
	},
	modalHeaderTitle: {
		boxSizing: 'border-box',
		color: 'white',
		flex: 1,
		fontSize: 20,
		margin: 0,
		padding: 0,
		textAlign: 'center',
	},
	modalOverlay: {
		height: '100%',
		width: '100%',
	},
	modalRoot: {
		bottom: 0,
		left: 0,
		position: 'fixed',
		right: 0,
		top: 0,
		zIndex: 5,
	},
	fieldError: {
		marginTop: 6,
	},
	subjectFieldInvalid: {
		...CssSelectors.allChildren(
			{
				borderColor: destructive,
			},
			'.text-input'
		),
	},
});
